module.exports = require("./compile/minified/ng-img-crop.js");
require("./compile/minified/ng-img-crop.css");


//////////////////
// WEBPACK FOOTER
// ngImgCrop (bower component)
// module id = 1197
// module chunks = 1